import { render } from "./dol-image-preview.vue?vue&type=template&id=22517556"
import script from "./dol-image-preview.vue?vue&type=script&lang=js"
export * from "./dol-image-preview.vue?vue&type=script&lang=js"

import "./dol-image-preview.vue?vue&type=style&index=0&id=22517556&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__